import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { api } from "../utils/apiClient";
import type { UsersResponse } from "../types";
import { USER_MANAGEMENT_STALE_TIME } from "../constants/userManagement";

type UseUsersQueryParams = {
  search?: string;
  page?: number;
  size?: number;
};

const DEFAULT_PAGE_SIZE = 10;

const buildUsersUrl = (params: UseUsersQueryParams): string => {
  const url = new URL("/api/v1/users", window.location.origin);
  url.searchParams.set("page", String(params.page ?? 0));
  url.searchParams.set("size", String(params.size ?? DEFAULT_PAGE_SIZE));
  if (params.search) {
    url.searchParams.set("search", params.search);
  }
  return url.pathname + url.search;
};

const fetchUsers = async (params: UseUsersQueryParams): Promise<UsersResponse> => {
  const res = await api.get(buildUsersUrl(params));
  if (!res.ok) throw new Error(`Failed to load users: ${res.status}`);
  return res.json();
};

export const useUsersQuery = ({ search, page = 0, size = DEFAULT_PAGE_SIZE }: UseUsersQueryParams = {}) => {
  return useQuery({
    queryKey: ["/api/v1/users", { search, page, size }],
    queryFn: () => fetchUsers({ search, page, size }),
    placeholderData: keepPreviousData,
    staleTime: USER_MANAGEMENT_STALE_TIME,
  });
};
